const INTERACTIVE_SELECTOR =
  "a, button, input, label, select, textarea, [data-pending-open], [data-row-ignore]"

const onRowClick = (event) => {
  if (event.defaultPrevented) return
  if (event.button != null && event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  const row = event.target.closest?.("tr[data-row-href]")
  if (!row) return
  if (event.target.closest?.(INTERACTIVE_SELECTOR)) return

  const href = row.dataset.rowHref
  if (!href) return

  if (window.Turbolinks) {
    Turbolinks.visit(href)
  } else {
    window.location.href = href
  }
}

export const initBackofficeTableRowLinks = () => {
  if (document.documentElement.dataset.backofficeTableRowLinksInit === "true") return
  document.documentElement.dataset.backofficeTableRowLinksInit = "true"

  document.addEventListener("click", onRowClick)
}
